export const getLastYears = (count = 15) => {
    console.log(count)
    return Array.from({ length: count }).map((_, index) => (new Date().getFullYear()) - index)
}

// Primero, escapa cualquier carácter especial de 'text'
function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function highlight(original, text) {
    const term = escapeRegExp(text);
    const regex = new RegExp(term, 'gi'); // 'g' = global, 'i' = case-insensitive
    return original.replace(regex, match =>
        `<span style="background: yellow">${match}</span>`
    );
}